import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		user: null,
		token: null,
		count: null
	},
	mutations: {
		getcount(state, count) {
			setTimeout(() => {
				state.count = count
			}, 1000);

		}
	}

})

export default store
